<template>
  <v-main>
    <slot></slot>
  </v-main>
</template>

<script>
export default {
  data: () => ({}),
  components: {},
  methods: {},
  created() {},
  computed: {},
};
</script>
